import { cn } from "@/lib/cn";
import { toAbsoluteUrl } from "@/lib/url";

/**
 * The brand mark, served from `public/media/images/favicon.png`.
 *
 * Resolved once at module scope rather than per render: the path is constant,
 * and an `src` recomputed on every render is a string the browser has to
 * re-check against its cache on every commit.
 */
const MARK_SRC = toAbsoluteUrl("media/images/favicon.png");

interface WordmarkProps {
  /** Mark only, no lettering. For the collapsed rail and the mobile header. */
  compact?: boolean;
  className?: string;
}

export function Wordmark({ compact, className }: WordmarkProps) {
  return (
    <div className={cn("flex min-w-0 items-center gap-2.5", className)}>
      {/* The art is a photograph rather than a flat glyph, so it needs a
          border to end on — without the ring it bleeds into whatever surface
          it is on. `object-cover`, not `contain`: the source is square, and
          `contain` would letterbox it inside its own rounded corners if that
          ever changes. */}
      <img
        src={MARK_SRC}
        alt=""
        aria-hidden="true"
        width={36}
        height={36}
        className="ring-border/70 size-9 shrink-0 rounded-lg object-cover ring-1"
      />

      {compact ? null : (
        <div className="min-w-0">
          <p className="text-content truncate text-[0.9375rem] leading-tight font-semibold tracking-tight">
            Algorithm Arena
          </p>
          <p className="text-content-subtle text-[0.6625rem] font-semibold tracking-[0.16em] uppercase">
            Admin panel
          </p>
        </div>
      )}
    </div>
  );
}
